module.exports = __webpack_public_path__ + "vco-icons.b0f49cd26ba67885381b.eot";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/storymap/icons/vco-icons.eot
// module id = ../../../../../src/styles/storymap/icons/vco-icons.eot
// module chunks = styles